"use strict";

PF.Model = class Model extends PF.Entity
	{
	static get options()
		{
		return {
			raw: {},

			url: `/represent/@{options.action}?represent=@{options.represent}&dicts=@{options.loadDicts}`,
			represent: undefined,
			loadDicts: true,

			filterConfig: {},
			where: "",
			loadOnInit: true,
			saveOnModify: false,
			saveDebounce: 500,
			params: {},
			dicts: {},
			isNewRecord: false,
			isNull: false,
			filterShow: true,
			removed: false,
			parent: undefined,
			toastOnSaveError: true,

			populateOptions: false,
		};
		}

	init()
		{
		super.init();
		this.options.dataKeys = {};

		this.calcString('options.url');
		this.setFilterByConfig(this.options.filterConfig);
		this.options.modify = {};
		this.options.hasModify = false;

		// this.onChange('options.hasModify', () => {
		// 	console.log('options.hasModify:', this.options.hasModify);
		// });

		this.options.loadStatus = 'init';
		this.options.newData = undefined;
		this.options.hasUnsaved = false;

		this.populateData(this.options.raw, this, true);

		if (this.options.represent !== undefined)
			{
			if (this.options.loadOnInit)
				{
				this.load();
				}
			else
				{
				this.options.loadStatus = 'loaded';
				}
			}
		else
			{
			this.options.loadStatus = 'loaded';
			}

		this.on('changed', () => {
			this.options.hasModify = true;
			if (this.options.parent !== undefined && this.makeRemoteChanges() === false)
				{
				this.options.parent.trigger('changed');
				}
		});

		// if (this.options.saveOnModify)
		// 	{
		// 	this.onFinish('changed', () => this.save(), this.options.saveDebounce);
		// 	}

		if (this.options.saveOnModify)
			{
			this.onFinish('changed', () => {
				if (this.options.form !== undefined)
				{
				if (this.options.form.validate(false))
					{
					this.save();
					}
				}
			}, this.options.saveDebounce);
			}
		}

	update()
		{
		this.options.loadStatus = 'loading';
		this.load('update');
		}

	load(source = 'init')
		{
		this.options.loadStatus = 'loading';
		let dictMaps = {};
		for (let dictName in this.options.dictMaps)
			{
			dictMaps[dictName + 'Schema'] = this.options.dictMaps[dictName];
			}
		let where = this.options.where;
		if (source === 'update')
			{
			if (where === '')
				{
				where = `id = '${this.id}'`;
				}
			else
				{
				where += ` and id = '${this.id}'`;
				}
			}


		let requestData = {
			schema: {
				filters: this.options.filter.toJSON(),
				where: where
			},
			...dictMaps,
			...this.options.params,
		};

		this.options.action = 'one';
		app.request(this.options.url, requestData, (response) => {

			if (response.dicts !== undefined)
				{
				for (let dictName in response.dicts)
					{
					this.options.dicts[dictName] = new PF.Models({raw: response.dicts[dictName].data});
					}
				}


			this.populateData(response.data, this, true);
			// this.hasModify = false;
			this.options.loadStatus = 'loaded';
			if (source === 'init')
				{
				this.trigger('loaded');
				}
			if (source === 'update')
				{
				this.trigger('updated');
				}
		});
		}

	get populateExceptions()
		{
		return {};
		}

	populateData(data, target = this, silent = false)
		{
		this.pauseEvent("changed");
		if (data instanceof PF.Entity)
			{
			data = data.toJSON();
			}
		if (data === null || data === undefined)
			{
			target.options.isNull = true;
			}
		else
			{
			target.options.isNull = false;
			}
		for (let key in data)
			{

			if (key in target.populateExceptions)
				{
				target.setData(key, data[key], silent);
				}
				// else if (data[key] === null)
				// 	{
				// 	target.setData(new PF.Model({raw: null}));
			// 	}
			else if (typeof data[key] !== 'object' || data[key] === null || key.startsWith('#'))
				{
				target.setData(key, data[key], silent);
				}
			else
				{
				if (!(data[key].constructor.name === 'Object' || data[key].constructor.name === 'Array'))
					{
					target.setData(key, data[key], silent);
					}
				else if (data[key] instanceof Object && !(data[key] instanceof Array))
					{
					if (target[key] instanceof PF.Model)
						{
						target[key].populateData(data[key]);
						target[key].options.parent = this;
						}
					else
						{
						let model = PF.Model.create(data[key], {parent: this});
						target.setData(key, model, silent);
						}
					}
				else if (data[key] instanceof Array || data[key] instanceof MK.Array)
					{

					if (target[key] instanceof PF.Models)
						{
						target[key].populateData(data[key]);
						target[key].parent = this;
						}
					else
						{
						let models = new PF.Models({raw: data[key], parent: this});
						target.setData(key, models, silent);
						}

					}
				}
			}
		this.resumeEvent("changed");
		}

	setData(path, value, silent = false)
		{
		let oldValue = this.get(path);
		let isEqual = false;
		if (oldValue instanceof PF.Model && value instanceof PF.Model)
			{
			isEqual = PF.H.compareByPks(oldValue, value);
			if (isEqual === true && oldValue !== value)
				{
				oldValue.populateData(value.toJSON(), oldValue, true);
				}
			}
		else
			{
			isEqual = PF.H.isSame(oldValue, value);
			}
		if (path === '#table' || path === '#pks')
			{
			this.set(path, value);
			return;
			}
		if (isEqual === false)
			{
			this.options.isNull = false;
			if (this.options.savingStatus === 'saving')
				{
				if (this.options.newData === undefined)
					{
					this.options.newData = new PF.Entity();
					}
				this.options.newData.setData(path, value);
				}
			else
				{
				super.setData(path, value);
				if (!silent)
					{
					this.trigger('changed', path);
					}
				}

			if (!silent)
				{
				this.options.modify[path] = true;
				this.options.hasModify = true;
				this.trigger('changed:' + path);
				}
			}
		}

	makeRemoteChanges()
		{
		if (this.options.represent !== undefined)
			{
			while (this.options.parent !== undefined)
				{
				if (this.options.parent.isNewRecord === true)
					{
					return false;
					}
				}
			return true;
			}
		return false;
		}

	saveRequestData()
		{
		return {row: this.toJSON()};
		}

	save()
		{
		this.trigger('save-start');
		this.options.savingStatus = 'saving';
		let requestData = this.saveRequestData();

		if (this.makeRemoteChanges() === true)
			{
			this.options.action = 'save';
			app.request(this.options.url, requestData, this.saveSuccess.bind(this), this.saveFailed.bind(this));
			}
		else
			{
			this.trigger('save-local');
			this.options.savingStatus = 'saved';
			this.options.isNewRecord = false;
			this.options.hasModify = false;
			}
		}

	saveSuccess(response)
		{
		if (response.status === "OK")
			{
			this.options.isNewRecord = false;
			this.options.savingStatus = 'saved';
			this.populateData(response.row);
			if (this.options.newData !== undefined)
				{
				this.populateData(this.options.newData);
				this.trigger('changed');
				}
			else
				{
				this.options.hasModify = false;
				}
			this.options.newData = undefined;
			this.options.modify = {};
			this.options.hasModify = false;

			this.trigger('save-success');
			}
		else
			{
			if (this.toastOnSaveError === true)
				{
				app.toast('Произошла ошибка при сохранении данных');
				}
			this.options.savingStatus = 'failed';
			}
		}

	saveFailed(code, errorText)
		{
		if (this.toastOnSaveError === true)
			{
			app.toast('Произошла ошибка при сохранении данных');
			}
		this.options.savingStatus = 'failed';
		}

	delete()
		{
		if (this.makeRemoteChanges() === true)
			{
			let requestData = {row: this.toJSON()};
			this.options.action = 'delete';
			app.request(this.options.url, requestData, this.deleteSuccess.bind(this));
			}
		else
			{
			this.trigger('save-local');
			}
		}

	markForDelete()
		{
		if (this.options.models !== undefined)
			{
			this.options.models.deleted.add(this);
			}
		}

	deleteSuccess(response)
		{
		if (response.status === "OK")
			{
			this.trigger('delete-success');
			}
		else
			{
			app.toast('Произошла ошибка при удалении данных');
			}
		}

	setFilterByConfig(filterConfig)
		{
		filterConfig.models = this;
		this.setFilter(new PF.Filter(filterConfig));
		}

	setFilter(filter)
		{
		this.options.filter = filter;
		this.options.filter.onFinish('change', () => this.load(), 50);
		}

	isNull()
		{
		return this.options.isNull;
		}

	destroy()
		{
		this.trigger('destroy');
		this.options.destroed = true;
		this.off();
		this.options.dom.destroy();
		}

	static create(data, options)
		{
		if (App.Models[data['#table']] !== undefined)
			{
			return new App.Models[data['#table']]({
				raw: data,
				...options
			});
			}
		if (data['#table'] === 'file')
			{
			return new PF.Model.File({
				raw: data,
				...options
			});
			}
		return new PF.Model({
			raw: data,
			...options
		});
		}
	};